import React from 'react'
import PropTypes from 'prop-types'

const propTypes = {
	// loader container height
	containerHeight: PropTypes.string
}

const defaultProps = {
	containerHeight: '100px',
}

class OxygenLoader extends React.Component {
	constructor(props) {
		super(props)
	}

	render() {
		const {
			containerHeight,
		} = this.props

		return (
			<div className="oxygen-loader" style={{ height: containerHeight }}>
				<div className="oxygen-loader-container">
					<div className="oxygen-loader-wrapper">
						<div className="bubble-wrapper bubble-wrap-1">
							<div className="oxygen-bubble bubble-last"></div>
							<div className="oxygen-bubble bubble-middle"></div>
						</div>
						<div className="bubble-wrapper bubble-wrap-2">
							<div className="oxygen-bubble bubble-middle"></div>
							<div className="oxygen-bubble bubble-last"></div>
						</div>
					</div>
				</div>
			</div>
		)
	}
}

OxygenLoader.propTypes = propTypes
OxygenLoader.defaultProps = defaultProps

export default OxygenLoader
